import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Calendar } from "lucide-react";
import { displayToast } from "../utils/Toast";
import { cleanReportName } from "../utils/Formatter";
import Print from "../assets/svgIcons/FormPrint.svg";
import "../styles/components/ReportsFilter.css";

const ReportsFilter = ({ reportCategory, report, selectedReport, tab }) => {
  const navigate = useNavigate();
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const getFormattedDate = (date) => {
    return date.toISOString().split("T")[0];
  };

  const getThreeMonthsAgo = () => {
    const today = new Date();
    const threeMonthsAgo = new Date(today);
    threeMonthsAgo.setMonth(today.getMonth() - 3);
    return threeMonthsAgo;
  };

  const [filterValues, setFilterValues] = useState({
    fromDate: getFormattedDate(getThreeMonthsAgo()),
    toDate: getFormattedDate(new Date()),
  });

  const isContractReviewManualReport =
    String(selectedReport?.name || "")
      .toLowerCase()
      .includes("contract review form");

  const isTrainingAttendanceManualReport =
    String(selectedReport?.name || "")
      .toLowerCase()
      .includes("training attendence") ||
    String(selectedReport?.name || "")
      .toLowerCase()
      .includes("training attendance");

  const isListOfEmployeesManualReport = String(selectedReport?.name || "")
    .toLowerCase()
    .includes("list of employees");

  const isListOfTrainersManualReport = String(selectedReport?.name || "")
    .toLowerCase()
    .includes("list of trainers");

  const isHrInductionTrainingSheetManualReport = String(
    selectedReport?.name || "",
  )
    .toLowerCase()
    .includes("induction training sheet");

  const isHrTrainingNeedsRecordManualReport = String(
    selectedReport?.name || "",
  )
    .toLowerCase()
    .includes("training needs record");

  const isHrEmployeeHistoryCardManualReport = String(
    selectedReport?.name || "",
  )
    .toLowerCase()
    .includes("employee history card");

  const isManualPreviewReport =
    selectedReport?.isManualTemplate ||
    isContractReviewManualReport ||
    isTrainingAttendanceManualReport ||
    isListOfEmployeesManualReport ||
    isListOfTrainersManualReport ||
    isHrInductionTrainingSheetManualReport ||
    isHrTrainingNeedsRecordManualReport ||
    isHrEmployeeHistoryCardManualReport;

  const handleProceed = () => {
    setIsButtonLoading(true);
    try {
      if (!filterValues.fromDate || !filterValues.toDate || !report) {
        displayToast("Please fill all the fields.");
      } else if (isManualPreviewReport) {
        navigate(`/${tab || "reports"}/${reportCategory}/transactions/invoice`, {
          state: {
            formData: {
              headDetails: {
                date: filterValues.toDate,
              },
              itemDetails: [],
              companyData: {},
              rowData: [],
              transactionCode:
                selectedReport?.templateCode ||
                (isTrainingAttendanceManualReport
                  ? "HT_TRAINING_ATTENDANCE"
                  : isListOfTrainersManualReport
                    ? "HR_LIST_OF_TRAINERS"
                  : isListOfEmployeesManualReport
                    ? "HR_LIST_OF_EMPLOYEES"
                    : isHrInductionTrainingSheetManualReport
                      ? "HR_INDUCTION_TRAINING_SHEET"
                    : isHrTrainingNeedsRecordManualReport
                      ? "HR_TRAINING_NEEDS_RECORD"
                    : isHrEmployeeHistoryCardManualReport
                      ? "HR_EMPLOYEE_HISTORY_CARD"
                    : "CONTRACT_REVIEW_FORM"),
            },
            selectedReportName: cleanReportName(selectedReport?.name),
          },
        });
      } else if (tab === "graphical-reports") {
        navigate(`/graphical-reports/${reportCategory}/charts`, {
          state: {
            reportsDataQuery: {
              id: selectedReport.id,
              start_date: filterValues.fromDate,
              end_date: filterValues.toDate,
              filter_data: selectedReport.filter_data,
              report_name: selectedReport.name,
            },
          },
        });
      } else
        navigate(`/reports/${reportCategory}/details`, {
          state: {
            reportsDataQuery: {
              id: selectedReport.id,
              start_date: filterValues.fromDate,
              end_date: filterValues.toDate,
              filter_data: selectedReport.filter_data,
              report_name: selectedReport.name,
            },
            selectedReportName: cleanReportName(selectedReport.name),
          },
        });
    } finally {
      setIsButtonLoading(false);
    }
  };

  return (
    <div className="filter-container">
      <h3 className="filter-title">Filter By Date</h3>

      <div className="filter-section">
        <div className="date-inputs">
          <div className="date-input-wrapper">
            <label className="filter-label">From</label>
            <input
              type="date"
              className={
                !filterValues.fromDate
                  ? "filter-input input-placeholder-color"
                  : "filter-input"
              }
              value={filterValues.fromDate || ""}
              onChange={(e) =>
                setFilterValues((prev) => ({
                  ...prev,
                  fromDate: e.target.value,
                }))
              }
              placeholder="From Date"
            />
            <Calendar className="calendar-icon" size={20} />
          </div>
          <div className="date-input-wrapper">
            <label className="filter-label">To</label>
            <input
              type="date"
              className={
                !filterValues.toDate
                  ? "filter-input input-placeholder-color"
                  : "filter-input"
              }
              value={filterValues.toDate || ""}
              onChange={(e) =>
                setFilterValues((prev) => ({ ...prev, toDate: e.target.value }))
              }
              placeholder="To Date"
            />
            <Calendar className="calendar-icon" size={20} />
          </div>
        </div>
      </div>
      {isButtonLoading ? (
        <div className="report-loader-container">
          <span className="report-loader"></span>
        </div>
      ) : (
        <button
          onClick={handleProceed}
          className={`proceed-button ${
            isManualPreviewReport ? "manual-preview-button" : ""
          }`}
        >
          {isManualPreviewReport && (
            <img src={Print} alt="print" className="manual-preview-icon" />
          )}
          {isManualPreviewReport ? "Print Preview" : "Proceed"}
        </button>
      )}
    </div>
  );
};
export default ReportsFilter;